import { Switch as MuiSwitch } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const Switch = styled(MuiSwitch)`
  ${({ theme }) => css`
    width: 52px;
    height: 32px;
    padding: 0;
    border-radius: 16px;

    .MuiSwitch-switchBase {
      padding: 5px;

      &.Mui-checked {
        color: ${theme.colors.lightest};

        + .MuiSwitch-track {
          background-color: ${theme.colors.secondary};
          opacity: 1;
        }

        &.Mui-disabled {
          color: ${theme.colors.gray[100]};

          + .MuiSwitch-track {
            opacity: 0.3;
          }
        }
      }

      &.Mui-disabled {
        color: ${theme.colors.gray.disabled};

        + .MuiSwitch-track {
          opacity: 0.5;
        }
      }
    }

    .MuiSwitch-thumb {
      width: 22px;
      height: 22px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .MuiSwitch-track {
      border-radius: 12px;
      background-color: ${theme.colors.gray.light};
      opacity: 1;
      transition: background-color 0.3s ease;
    }
  `}
`

export const Label = styled.label`
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    cursor: pointer;
    user-select: none;

    &:hover {
      transition: all 0.3s ease;
      filter: brightness(0.95);
    }
  `}
`
